import React from 'react';
import { Helmet } from 'react-helmet';

const PromoPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Promo — Arrangelly product walkthrough</title>
        <meta
          name="description"
          content="Watch the Arrangelly product walkthrough — lessons, bookings, and payments in one place."
        />
      </Helmet>
      <div className="w-full bg-slate-950">
        <iframe
          src="/promo/promo-walkthrough.html"
          title="Arrangelly product walkthrough"
          className="block w-full border-0"
          style={{ height: 'calc(100vh - 5.75rem)' }}
          allow="autoplay"
        />
      </div>
    </>
  );
};

export default PromoPage;
